export * from './paginator.module';
export * from './paginator.component';
